import {
    UPDATE_PASSWORD,
    UPDATE_PASSWORD_SUCCESS,
    UPDATE_PASSWORD_FAILURE,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE
} from "../Constants";

export const UpdatePasswordActions = (payload) => ({
    type: UPDATE_PASSWORD,
    payload
});

export const UpdatePasswordActionsSuccess = (payload) => ({
    type: UPDATE_PASSWORD_SUCCESS,
    payload
});

export const UpdatePasswordActionsFailure = (payload) => ({
    type: UPDATE_PASSWORD_FAILURE,
    payload
});

export const ResetPasswordActions = (payload) => ({
    type: RESET_PASSWORD,
    payload
});

export const ResetPasswordActionsSuccess = (payload) => ({
    type: RESET_PASSWORD_SUCCESS,
    payload
});

export const ResetPasswordActionsFailure = (payload) => ({
    type: RESET_PASSWORD_FAILURE,
    payload
});